import React from "react";
import styles from "./InputField.module.css";
import { FaCalendarAlt, FaClock } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { DatePicker } from "antd";
import TextComponent from "../textComponent/TextComponent";

const InputField = (props) => {
  return (
    <div
      className={`${styles.main_input} ${props?.className}`}
      style={props?.style}
    >
      {/* <text className={` ${styles.label} ${props?.labelClass} `}>
        <TextComponent>{props?.label}</TextComponent>
      </text> */}
      {props?.label ? (
        <TextComponent
          className={`${styles.label} ${props?.labelClass}`}
          color={props?.LabelColor ? props?.LabelColor : "var(--black-color)"}
          fontFamily={
            props?.LabelFontFamily ? props?.LabelFontFamily : "Urbanist-Medium"
          }
          padding={'0px'}
        >
          {props?.label}
        </TextComponent>
      ) : null}

      <div className={styles.input} style={props.inputStyle}>
        {props?.leftIcon ? (
          <div className={styles.leftIcon} onClick={props?.onleftIconPress}>
            {props?.leftIcon}
          </div>
        ) : null}

        {props?.textArea ? (
          <textarea
            placeholder={props?.placeholder}
            className={`${styles.inner_textArea} ${props?.inputClass}`}
            style={{ height: props?.rows ? null : "32px", marginTop: "10px" }}
            name={props?.name}
            disabled={props?.disabled}
            // value={props?.value}
            onChange={props?.onChange}
            type={props?.type}
            maxLength={props?.maxLength}
            value={props?.value}
            defaultValue={props?.defaultValue}
            rows={props?.rows}
          ></textarea>
        ) : (
          <input
            style={props?.innerInput}
            placeholder={props?.placeholder}
            className={`${styles.inner_input} ${props?.inputClass}`}
            name={props?.name}
            disabled={props?.disabled}
            // value={props?.value}


            onChange={(e) => {
              let value = e.target.value;
              if (props.type === "number") {
                value = value.replace(/[^0-9.]/g, "");
                if (props.maxLength && value.length > props.maxLength) {
                  return;
                }
              }
              props?.onChange?.({
                ...e,
                target: {
                  ...e.target,
                  value,
                },
              });
            }}

            type={props?.type}
            maxLength={props?.maxLength}
            value={props?.value}
            defaultValue={props?.defaultValue}

          />
        )}

        {props?.rightIcon ? (
          <div className={styles.rightIcon} onClick={props?.onRightIconPress}>
            {props?.rightIcon}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default InputField;
